import React, { useContext, useMemo, useReducer, useState } from "react";
import { ReactComponent as ErrorIcon } from "../../img/ErrorIcon.svg";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { StyledGoBack, StyledInBoxFrame, StyledInBoxFrameHeader, StyledSmallError } from "../style/global.style";
import ContentBox from "../../move2FComponents/ContentBox";
import { StyledInnerPage } from "./setup.style";
import { ReactComponent as LeftArrow } from "../../img/Left_Arrow.svg";
import { ReactComponent as PinterestIconSmall } from "../../img/PinterestIcon_small.svg";
import { ReactComponent as MicrosoftIconSmall } from "../../img/MicrosoftIcon_small.svg";
import { ReactComponent as TaboolaIconSmall } from "../../img/TaboolaIcon_small.svg";
import { ReactComponent as OutBrainIconSmall } from "../../img/OutBrainIcon_small.svg";
import ToggleButton from "../utils/ToggleButton";
import StateContext from "../../context/StateContext";
import { updateSegment } from "../../services/globalService";
import { updateSegmentInData } from "../../services/dataService";
import SaveButton from "../../move2FComponents/SaveButton";
import SmallLoader from "../../components/utils/SmallLoader";
import { captureException } from "services/sentry";

const stateReducerFunc = (state, action) => {
	if (action.type === "ua") return { ...state, ua: action.payload };
	if (action.type === "gapi" && state.gapi) return { ...state, ua: "", gapi: false };
	return { ...state, [action.type]: !state[action.type] };
};
const ConnectPlatforms = () => {
	const { segMap, segments, ACTIONS, dispatch } = useContext(StateContext);
	const [errorMessage, setErrorMessage] = useState("");
	const history = useHistory();
	const { code } = useParams();
	const initValue = useMemo(
		() =>
			segMap && segMap[code]?.install_data?.options
				? { ...segMap[code].install_data.options, ua: segMap[code].install_data.ua }
				: { gapi: false, fb: false, pt: false, ms: false, tb: false, ua: "", ob: false },
		[code, segMap]
	);
	const [options, dispatchOptions] = useReducer(stateReducerFunc, initValue);
	const location = useLocation();
	const [showSpinner, setShowSpinner] = useState(false);
	// /segments/create/platforms --> /segments/create/
	// /segments/create/:code/platforms --> /segments/create/:code
	const prevLocation = useMemo(() => {
		return location.pathname.replace("/platforms", "");
	}, [location]);

	const togglePlatform = (e) => {
		dispatchOptions({ type: e.target.name });
	};
	const prepInstallData = () => {
		const newInstallData = { ...segMap[code].install_data };
		if (options.ua) newInstallData.ua = options.ua;
		if (!options.gapi && newInstallData.ua) newInstallData.ua = "";
		newInstallData.options.gapi = options.gapi;
		newInstallData.options.ga = options.ga;
		newInstallData.options.ms = options.ms;
		newInstallData.options.pt = options.pt;
		newInstallData.options.ob = options.ob;
		newInstallData.options.tb = options.tb;
		return newInstallData;
	};
	const onSave = async (e) => {
		e.preventDefault();
		try {
			setShowSpinner(true);
			let payload = {};
			// update the segment only if have code
			const res = await updateSegment({ id: code, data: { install_data: prepInstallData() } });
			if (res?.data) {
				const newSegment = res.data;
				const { newSegments, newMap } = updateSegmentInData(newSegment, segments, segMap);
				payload = { segments: newSegments, segMap: newMap };
				dispatch({ type: ACTIONS.SET_STATE, payload });
				setShowSpinner(false);
				history.push(prevLocation);
			}
		} catch (e) {
			setErrorMessage(e.data);
			dispatch({ type: ACTIONS.SET_CODE, payload: null });
			console.error("CreateSegment.js ~ saveName ~ error", e);
			setTimeout(() => {
				setErrorMessage("");
				setShowSpinner(false);
				history.push(prevLocation);
			}, 2000);
			captureException(e, "error", {}, { action: "onSave", description: "failed saving changes on platforms" }, { scope: "connectPlatforms.js" });
		}
	};

	return (
		<StyledInnerPage>
			<StyledGoBack disabled={showSpinner} as={Link} to={prevLocation}>
				<LeftArrow />
				Go Back
			</StyledGoBack>
			<ContentBox title="Reach high value users, wherever they are">
				<p>Fixel automagically integrates with your favorite ad platforms for creating high value audiences.</p>
				<StyledInBoxFrame>
					<StyledInBoxFrameHeader>
						<h3>
							<PinterestIconSmall />
							Pinterest Ads
						</h3>
						<ToggleButton name="pt" disabled={showSpinner} onChange={togglePlatform} isChecked={options.pt} />
					</StyledInBoxFrameHeader>
				</StyledInBoxFrame>
				<StyledInBoxFrame>
					<StyledInBoxFrameHeader>
						<h3>
							<MicrosoftIconSmall />
							Microsoft Ads (formerly Bing Ads)
						</h3>
						<ToggleButton name="ms" disabled={showSpinner} onChange={togglePlatform} isChecked={options.ms} />
					</StyledInBoxFrameHeader>
				</StyledInBoxFrame>
				<StyledInBoxFrame>
					<StyledInBoxFrameHeader>
						<h3>
							<OutBrainIconSmall />
							Outbrain
						</h3>
						<ToggleButton name="ob" disabled={showSpinner} onChange={togglePlatform} isChecked={options.ob} />
					</StyledInBoxFrameHeader>
				</StyledInBoxFrame>
				<StyledInBoxFrame>
					<StyledInBoxFrameHeader>
						<h3>
							<TaboolaIconSmall />
							Taboola
						</h3>
						<ToggleButton name="tb" disabled={showSpinner} onChange={togglePlatform} isChecked={options.tb} />
					</StyledInBoxFrameHeader>
				</StyledInBoxFrame>
				{errorMessage ? (
					<StyledSmallError>
						<ErrorIcon />
						{errorMessage}
					</StyledSmallError>
				) : null}
				<SaveButton
					type="button"
					onClick={onSave}
					disabled={!code || (options.gapi && !options.ua) || showSpinner}
					label={showSpinner ? <SmallLoader inline={true} /> : "Save"}
					alignTo="left"
				/>
			</ContentBox>
		</StyledInnerPage>
	);
};
export default ConnectPlatforms;
